// Path: ./src/app/components/CreateRoleCard/styled.ts
import styled from "styled-components";

export const PermissionGroupTableWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: start;
  margin: auto;
  max-width: 970px;
  flex-wrap: wrap;
`;
